const messages = {
    'masterdata.add.success': '主数据添加成功!',
    'masterdata.edit.success': '主数据编辑成功!',
    'masterdata.delete.success': '主数据删除成功!',
    'emailtemplate.add.success': '邮件模板添加成功!',
    'emailtemplate.edit.success': '邮件模板编辑成功!',
    'emailtemplate.delete.success': '邮件模板删除成功!',
    'system.leavewithoutsaving.title': '系统通知',
    'system.leavewithoutsaving.content': '如果您离开当前页面，未保存的数据将会丢失。您确定要离开吗？',
    'carriers.add.success': '承运商添加成功!',
    'carriers.edit.success': '承运商编辑成功!',
    'carriers.delete.success': '承运商删除成功!',
    'carriersaccount.authorize.success': '授权邮件发送成功!',
    'freightbillaccount.add.success': '运费账单账户添加成功!',
    'freightbillaccount.edit.success': '运费账单账户编辑成功!',
    'freightbillaccount.delete.success': '运费账单账户删除成功!',
    'accounts.add.success': '账户添加成功!',
    'accounts.edit.success': '账户编辑成功!',
    'accounts.delete.success': '账户删除成功!',
    'freight.updatestauts.success':'更新状态成功!',
    'waybill.updatestatus.success':'更新打印状态成功!',
    'freight.upload.success':'上传成功!',
    'freight.sendtodppo.success':'成功发送到 DPPO!',
    'freight.getdhlbilling.success':"成功获取 DHL 账单!",
    'freight.getdhlbilling.fail':"获取 DHL 账单失败!",
    'freight.export.fail':'导出失败!',
    'freight.senddppo.fail': "发送到 PO 失败!",
    'waybill.getprintwaybilldocument.success':'获取打印运单文档成功!',
    'company.add.success': '公司添加成功!',
    'company.edit.success': '公司编辑成功!',
    'company.delete.success': '公司删除成功!',
    'company.contacts.tips': '在多个值之间使用; 分隔',
    'department.add.success': '部门添加成功!',
    'department.edit.success': '部门编辑成功!',
    'department.delete.success': '部门删除成功!',
    'carrieraccount.password.tips': '如果您需要更改密码，请输入',
    'carrieraccount.appsecret.tips': '如果您需要更改应用密钥，请输入',
    'carrieraccount.aessecret.tips': '如果您需要更改 AES 密钥，请输入',
    'region.add.success': '区域添加成功!',
    'region.edit.success': '区域编辑成功!',
    'region.delete.success': '区域删除成功!',
    'addressbook.save.success': '地址保存成功!',
    'addressbook.add.success': '地址簿添加成功!',
    'addressbook.edit.success': '地址簿编辑成功!',
    'addressbook.delete.success': '地址簿删除成功!',
    'address.required.tip': '请提供完整的地址信息!',
    'address.selectone.tip': '请选择一个地址!',
    'country.save.success': '国家/地区保存成功!',
    'country.add.success': '国家/地区添加成功!',
    'country.edit.success': '国家/地区编辑成功!',
    'country.delete.success': '国家/地区删除成功!',
    'hscode.add.success': 'HS编码添加成功!',
    'hscode.edit.success': 'HS编码编辑成功!',
    'hscode.delete.success': 'HS编码删除成功!',
    'legalunit.add.success': '法律实体添加成功!',
    'legalunit.edit.success': '法律实体编辑成功!',
    'legalunit.delete.success': '法律实体删除成功!',
    'sparrowtemplate.add.success': 'Sparrow模板添加成功!',
    'sparrowtemplate.edit.success': 'Sparrow模板编辑成功!',
    'sparrowtemplate.delete.success': 'Sparrow模板删除成功!',
    'expressorder.save.success': '快递订单保存成功!',
    'expressorder.edit.success': '快递订单编辑成功!',
    'expressorder.delete.success': '快递订单删除成功!',
    'expressorder.submit.success': '快递订单提交成功!',
    'expressorder.process.success': '快递订单处理成功!',
    'expressorder.cancel.success': '快递订单取消成功!',
    'expressorder.signback.tip': '如果选择是，则需要纸质POD（交付证明），并将产生相应的运费。',
    'expressorder.address.citytip': '城市格式：厦门市',
    'mobile.expressorder.cargo.notice': '注意：实际重量和体积由送货人员确定。包装后物品的重量可能会增加，费用将根据体积和重量收取，当重量较小而体积较大时',
    'freight.confirmbilling.success': '账单确认成功!',
    'freight.approvebilling.success': '账单审批成功!',
    'purchaserequest.save.success': '采购请求保存成功!',
    'purchaserequest.submit.success': '采购请求提交成功!',
    'purchaserequest.process.success': '采购请求处理成功!',
    'purchaserequest.cancel.success': '采购请求取消成功!',
    'purchaserequest.netamount.cannotempty': '请维护净价的值!',
    'expressorder.plannedshippingdatetime.tip': '提货时间-发货时间≥120分钟',
    'expressorder.isNeutraldelivery.tip': '仅支持DHL',
    'expressorder.cargoType.tip': '包裹的描述必须使用英文',
    'expressorder.cargo.cannotempty': '包裹信息不能为空，请检查!',
    'expressorder.plannedshippingdatetimeandpickuptime.tip': '上门提货只能预约在5点前，如果有紧急快件请联系快递员（周末休息日不提供上门取件）',
    'expressorder.exportdeclaration.cannotempty': '发票上的行项目不能为空，请检查!',
    'expressorder.datePickCheck.pickTimesmall': '提货日期时间必须晚于计划发货日期时间2小时',
    'freightbill.records.cannotempty': '请选择需要操作的账单记录!',
    'delegation.disable.success': 'Delegation disabled successfully!',
    'delegation.enable.success': 'Delegation enabled successfully!'
  };
  export default messages;
  